import React from 'react'

function BookingSidebar({ 
  selectedService, 
  selectedWorker, 
  selectedDate, 
  selectedTime, 
  currentStep,
  onContinue 
}) {
  return (
    <div className="booking-sticky-sidebar">
      <div className="booking-sticky-card">
        <h4>Booking Summary</h4>
        
        {selectedService ? (
          <div className="selected-service-summary">
            <h5>Service</h5>
            <div className="service-details-summary">
              <span className="service-name-summary">{selectedService.service || selectedService.service_name}</span>
            </div>
              {selectedService.price !== 0 && <span className="service-duration-summary"><strong>{selectedService.min_price ? `From £${selectedService.price}` : `£${selectedService.price}`}</strong></span>}
              <span className="service-duration-summary">{selectedService.duration} minutes</span>
          </div>
        ) : (
          <div className="placeholder-section">
            <h5>Service</h5>
            <span className="placeholder-text">Select a service</span>
          </div>
        )}

        {(selectedWorker && currentStep >= 2) ? (
          <div className="selected-worker-summary">
            <h5>Worker</h5>
            <div className="worker-name-summary">{selectedWorker.name}</div>
            <div className="worker-specialty-summary">{selectedWorker.specialty}</div>
          </div>
        ) : currentStep >= 2 ? (
          <div className="placeholder-section">
            <h5>Worker</h5>
            <span className="placeholder-text">Choose your Worker</span>
          </div>
        ) : null}

        {(selectedDate && selectedTime && currentStep >= 3) ? (
          <div className="selected-datetime-summary">
            <h5>Date & Time</h5>
            <span className="date-summary">{new Date(selectedDate).toLocaleDateString('en-US', { 
              weekday: 'long', 
              month: 'long', 
              day: 'numeric' 
            })}</span>
            <span className="time-summary">{selectedTime}</span>
          </div>
        ) : currentStep >= 3 ? (
          <div className="placeholder-section">
            <h5>Date & Time</h5>
            <span className="placeholder-text">Select date and time</span>
          </div>
        ) : null}

        {selectedService && selectedService.price > 0 && (
          <div className="total-section">
            <div className="total-row">
              <span>Total to pay:</span>
              <span className="total-price">{selectedService.has_deposit ? `£${(selectedService.price * selectedService.deposit_fraction).toFixed(2)}` : `£${selectedService.price.toFixed(2)}`}</span>
            </div>
          </div>
        )}

        {/* Continue Button */}
        {((currentStep === 1 && selectedService) || 
          (currentStep === 2 && selectedWorker) || 
          (currentStep === 3 && selectedDate && selectedTime)) && (
          <button className="sidebar-continue-btn" onClick={onContinue}>
            Continue
          </button>
        )}
      </div>
    </div>
  )
}

export default BookingSidebar